import React, {useContext} from "react";
import emoji from "react-easy-emoji";
import {Fade} from "react-reveal";

import ResearchArea from "../../components/researchAreas/ResearchArea";
import StyleContext from "../../contexts/StyleContext";
import {areasSection, greeting} from "../../portfolio";

import "./Areas.scss";

export default function Areas() {
  const {isDark} = useContext(StyleContext);
  if (!areasSection.display) {
    return null;
  }
  return (
    <div className={isDark ? "dark-mode main" : "main"} id="areas">
      <div className="areas-main-div">
        <Fade right duration={1000}>
          <div className="areas-text-div">
            {greeting.displayGreeting && (
              <div className="merged-greeting">
                <h1
                  className={
                    isDark ? "dark-mode greeting-text" : "greeting-text"
                  }
                >
                  {greeting.title}{" "}
                  <span className="wave-emoji">{emoji("👋")}</span>
                </h1>
                <p
                  className={
                    isDark
                      ? "dark-mode greeting-text-p"
                      : "greeting-text-p subTitle"
                  }
                >
                  {greeting.subTitle}
                </p>
              </div>
            )}

            <h1
              className={isDark ? "dark-mode areas-heading" : "areas-heading"}
            >
              {areasSection.title}{" "}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle areas-text-subtitle"
                  : "subTitle areas-text-subtitle"
              }
            >
              {areasSection.subTitle}
            </p>
            <ResearchArea />
            <div>
              {areasSection.areas.map((areas, i) => {
                return (
                  <p
                    key={i}
                    className={
                      isDark
                        ? "dark-mode subTitle areas-text"
                        : "subTitle areas-text"
                    }
                  >
                    {areas}
                  </p>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
